<template>
  <div v-if="visible">
    <section class="d-flex justify-content-between">
      <div @click="$emit('on-toggle')">
        <div class="-clickable">
          <span class="-bold">{{ store.Model.Name }}</span
          ><span v-if="store.DistanceKm > 0" class="-gray-dark m-l-6"
            >{{ store.DistanceKm }}km</span
          >
        </div>
        <div v-if="!compact" class="m-t-6">
          <div>{{ store.Model.VisitorAddress.Line1 }}, {{ store.Model.VisitorAddress.City }}</div>
          <div v-if="openToday">
            <span>{{ insertString("FindStore", "OpenToday") }}:</span>&nbsp;
            <span>{{ openToday.OpenHour }}</span>
            <span v-if="openToday.OpenMinute">.{{ openToday.OpenMinute }}</span>
            -
            <span>{{ openToday.CloseHour }}</span>
            <span v-if="openToday.CloseMinute"
              >.{{ openToday.CloseMinute }}</span
            >
          </div>
          <div v-if="storePageUrl && open">
            <a class="-blue -clickable" :href="storePageUrl">{{ insertString("FindStore", "StorePageLink") }}</a>
          </div>
        </div>
      </div>
      <div
        v-if="open && viewCloseButton"
        class="storefinder-result-close d-flex justify-content-end"
      >
        <div class="-clickable" @click="$emit('close')">
          <SvgComponent :icon="{ name: 'Close' }" />
        </div>
      </div>
    </section>
    <TransitionExpand v-if="!compact">
      <slot />
    </TransitionExpand>
    <section v-if="!compact" class="d-flex justify-content-between m-t-12">
      <div class="d-flex flex-wrap -gray-dark">
        <!-- <div class="m-r-6">Premium retailer</div> -->
        <div v-if="store.Model.HasReserveInStore" class="m-r-9 -nowrap">
          {{ insertString("FindStore", "HasReserveInStore") }}
        </div>
        <div v-if="store.Model.HasPickupInStore" class="m-r-9 -nowrap">
          {{ insertString("FindStore", "HasPickupInStore") }}
        </div>
        <div v-if="store.Model.HasOrderFromStore" class="m-r-9 -nowrap">
          {{ insertString("FindStore", "HasOrderFromStore") }}
        </div>
        <div v-if="store.Model.HasTwoHourDelivery" class="m-r-9 -nowrap">
          {{ insertString("FindStore", "HasTwoHourDelivery") }}
        </div>

        <div>&nbsp;</div>
      </div>
      <div>
        <div
          class="-blue -clickable -nowrap"
          @click="$emit('on-toggle')"
          v-html="!open ? 'More info' : ''"
        ></div>
      </div>
    </section>
  </div>
</template>
<script>
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';
import { getOpenToday, storePageUrl } from '@/Scripts/lib/helper/storeHelper.js';

const TransitionExpand = () => import(/* webpackChunkName: "TransitionExpand" */ '@/Scripts/components/shared/Transitions/TransitionExpand.vue');

export default {
  components: {
    SvgComponent,
    TransitionExpand

  },
  props: {
    store: Object,
    index: Number,
    open: Boolean,
    compact: Boolean,
    viewCloseButton: Boolean,
    visible: Boolean

  },
  computed: {
    storePageUrl () {
      return storePageUrl(this.store.Model.Key, document.documentElement.lang);
    },

    openToday () {
      if (this.store.Model.OpeningHours && this.store.Model.OpeningHours.length) {
        return getOpenToday(this.store.Model.OpeningHours);
      }
      return null;
    }
  }
};
</script>
